// @flow
import * as React from "react";

import type { ThemeMode } from "types/theme";

export type ThemeContextType = {
  theme: ThemeMode,
  setTheme: (theme: ThemeMode) => void,
  toggleTheme: () => void,
};

const ThemeContext: React.Context<ThemeContextType | null> = React.createContext<ThemeContextType | null>(null);

export default ThemeContext;
